import Pagination from 'rc-pagination/lib/locale/zh_TW';
import DatePicker from '../date-picker/locale/zh_TW';
import TimePicker from '../time-picker/locale/zh_TW';
import Calendar from '../calendar/locale/zh_TW';
export default {
    locale: 'zh-tw',
    Pagination,
    DatePicker,
    TimePicker,
    Calendar,
    Table: {
        filterTitle: '',
        filterConfirm: ' ',
        filterReset: ' ',
        emptyText: '',
        selectAll: '',
        selectInvert: '',
    },
    Modal: {
        okText: ' ',
        cancelText: ' ',
        justOkText: 'OK',
    },
    Popconfirm: {
        okText: ' ',
        cancelText: ' ',
    },
    Transfer: {
        notFoundContent: '',
        searchPlaceholder: '',
        itemUnit: '',
        itemsUnit: '',
    },
    Select: {
        notFoundContent: '',
    },
    Upload: {
        uploading: '...',
        removeFile: '',
        uploadError: '',
        previewFile: '',
    },
};



// WEBPACK FOOTER //
// ./components/locale-provider/zh_TW.tsx